import {Injectable} from '@angular/core';
import {TypeAdresseEnum,TypeAdresseRef} from "@domain/geolocalisation/type-adresse";

/**
 * Service local pour les adresses
 *
 * @author Lionel Gimenez
 * @date 14/04/2025
 */
@Injectable()
export class AdresseService {
    /**
     * Retourne l'icône à afficher suivant le type d'adresse personnelle / professionelle
     *
     * @param typeAdresse personnelle / professionelle
     */
    getIconeForTypeAdresse(typeAdresse: string): string {
        return TypeAdresseRef.find(typeAdresse)?.type == TypeAdresseEnum.PERSONNELLE ? 'home' : 'business';
    }
}